export function getIconBrandPrefix(client: string | null | undefined): string {
  if (client === 'fido' || client === 'media' || client === 'media_dis') {
    return 'fds';
  }

  if (client === 'chatr' || client === 'cpp') {
    return 'cds';
  }

  return 'rds';
}
